export default __webpack_public_path__ + "static/media/CLIENTE_7.859d852f.png";